import type { SVGProps } from "react";
export interface AgeLimit21IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AgeLimit21Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AgeLimit21IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 12C.875 5.857 5.856.876 12.001.876q.75 0 1.476.097l.48.074.113.027a1.126 1.126 0 0 1-.392 2.203l-.115-.013-.382-.06a8.876 8.876 0 1 0 7.557 7.233l1.108-.196 1.107-.198a11 11 0 0 1 .172 1.959c0 6.143-4.98 11.123-11.124 11.124C5.856 23.125.875 18.145.875 12m20.774-2.868a1.124 1.124 0 0 1 1.304.91l-2.215.394c-.108-.612.3-1.195.911-1.304"
      />
      <path
        fill={color}
        d="M10.125 10.3v-.05c0-.61-.505-1.125-1.125-1.125-.56 0-1.052.384-1.18.78a1.125 1.125 0 0 1-2.14-.698C6.14 7.8 7.56 6.875 9 6.875c1.88 0 3.375 1.54 3.375 3.375v.05c0 1.051-.463 1.818-1.084 2.365-.564.498-1.28.83-1.815 1.08-.607.283-1.02.478-1.308.715-.18.147-.256.266-.281.414h3.363l.116.006a1.126 1.126 0 0 1 0 2.239l-.116.006H7a1.375 1.375 0 0 1-1.375-1.374V15c0-1.038.497-1.773 1.113-2.28.556-.457 1.268-.773 1.786-1.015.59-.275.999-.481 1.279-.728.223-.197.322-.38.322-.678Zm5.25 5.7v-5.007a3.1 3.1 0 0 1-.89.131h-.235a1.125 1.125 0 0 1 0-2.25h.234a.875.875 0 0 0 .869-.766l.03-.247A1.126 1.126 0 0 1 17.626 8v8a1.125 1.125 0 0 1-2.25 0Zm3-9V5.625H17a1.126 1.126 0 0 1 0-2.25h1.375V2a1.125 1.125 0 0 1 2.25 0v1.375H22a1.125 1.125 0 0 1 0 2.25h-1.375V7a1.125 1.125 0 0 1-2.25 0"
      />
    </svg>
  );
}
